var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alerts, Warning, Signs Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9076 3.02355C11.9337 3.00907 11.9662 3 12.0023 3C12.0384 3 12.071 3.00907 12.097 3.02355C12.1195 3.03604 12.1492 3.05889 12.1791 3.10969L22.4645 20.6097C22.518 20.7007 22.5169 20.796 22.4677 20.8847C22.443 20.9292 22.4122 20.9585 22.3857 20.975C22.3636 20.9887 22.3351 21 22.2877 21H1.71689C1.66955 21 1.64107 20.9887 1.61898 20.975C1.59244 20.9585 1.56158 20.9292 1.53691 20.8847C1.4877 20.796 1.48663 20.7007 1.54012 20.6097L11.8256 3.10969C11.8554 3.05889 11.8851 3.03604 11.9076 3.02355ZM13.4723 2.34963C12.8064 1.21679 11.1982 1.21679 10.5324 2.34963L0.246939 19.8496C-0.43861 21.0161 0.384418 22.5 1.71689 22.5H22.2877C23.6202 22.5 24.4432 21.0161 23.7577 19.8496L13.4723 2.34963Z",
    fill: "#0E0748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5023 18C10.5023 17.1716 11.1739 16.5 12.0023 16.5C12.8307 16.5 13.5023 17.1716 13.5023 18C13.5023 18.8284 12.8307 19.5 12.0023 19.5C11.1739 19.5 10.5023 18.8284 10.5023 18Z",
    fill: "#0E0748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6493 8.99256C10.5693 8.19343 11.1969 7.5 12 7.5C12.8031 7.5 13.4307 8.19343 13.3507 8.99256L12.8246 14.2537C12.7823 14.6774 12.4258 15 12 15C11.5742 15 11.2177 14.6774 11.1754 14.2537L10.6493 8.99256Z",
    fill: "#0E0748"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1b8ae204ea7fc5af7eaa3518991b6a95.svg";
export { ForwardRef as ReactComponent };